import React from "react";
import { Edit, useForm } from "@refinedev/antd";
import { Form, Input, InputNumber, Switch } from "antd";
import { ICurrency } from "../../interfaces/currency";

export const CurrencyEdit: React.FC = () => {
    const { formProps, saveButtonProps, queryResult } = useForm<ICurrency>({
        meta: {
            fields: [
                "id",
                "currencyCode",
                "name",
                "symbol",
                "isActive",
                "isBaseCurrency",
                "exchangeRate",
            ],
        },
        warnWhenUnsavedChanges: true,
    });

    const currencyData = queryResult?.data?.data;

    return (
        <Edit saveButtonProps={saveButtonProps}>
            <Form {...formProps} layout="vertical">
                <Form.Item
                    label="Code"
                    name="currencyCode"
                    rules={[{ required: true }]}
                >
                    <Input placeholder="e.g. USD" maxLength={10} disabled />
                </Form.Item>

                <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true }]}
                >
                    <Input placeholder="e.g. United States Dollar" />
                </Form.Item>

                <Form.Item
                    label="Symbol"
                    name="symbol"
                    rules={[{ required: true }]}
                >
                    <Input placeholder="e.g. $" maxLength={5} />
                </Form.Item>

                <Form.Item
                    label="Exchange Rate"
                    name="exchangeRate"
                    rules={[{ required: true, type: 'number', min: 0.000001 }]}
                >
                    <InputNumber
                        placeholder="e.g. 1.0"
                        step={0.0001}
                        precision={4}
                        style={{ width: '100%' }}
                    />
                </Form.Item>

                <Form.Item
                    label="Is Base Currency"
                    name="isBaseCurrency"
                    valuePropName="checked"
                >
                    <Switch />
                </Form.Item>

                <Form.Item
                    label="Is Active"
                    name="isActive"
                    valuePropName="checked"
                >
                    <Switch />
                </Form.Item>
            </Form>
        </Edit>
    );
}; 